import React, {useEffect} from 'react'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import {useSelector} from 'react-redux'
import {frequencyFromExpiresIn} from 'components/NewOfferingButton'

const buildPricingTextFromOffering = ({discountType, expiresIn, firstPeriodPrice, price, freeTrialPeriodDays}) => {

    if (!expiresIn) {
        return
    }

    const frequency = frequencyFromExpiresIn(expiresIn)
    
    if (discountType === 'firstPeriodDiscount') {
        return `First ${frequency.replace("ly", "")} for $${firstPeriodPrice}, then $${price} ${frequency} until canceled.`

    } else if (discountType === 'freeTrial') {
        return `First ${freeTrialPeriodDays ?? 0} days free, then $${price} ${frequency} until canceled.`
    }

    return null
}

function PricingOptionCell({selected, onClick, model}) {

    let view = (
        <div>
            <h6>{model?.name ?? "Pricing Option"}</h6>
            {true && (
                // <p className="mb-0">{model?.price ? currencyFormatter.format(model.price) : "unknown"}</p>
                <p className="mb-0">{model?.price ?? "unknown"}</p>
            )}
        </div>
    )

    return (
        // onClick={() => setSelectedIndex(index)}
        // <div onClick={onClick} key={index} className={`card w-100 my-3 p-2 ${selectedIndex === index ? "border border-primary" : ""}`}></div>
        <div onClick={onClick} className={`card w-100 my-3 p-2 ${selected ? "border border-primaryColor" : ""}`}>
            <div className="d-flex d-row justify-content-between align-items-center">
                {view}
                {selected ? (
                    <RadioButtonCheckedIcon className="primaryColor" />
                ) : (
                    <RadioButtonUncheckedIcon className="primaryColor" />
                )}
            </div>
            
        </div>

    )
}

// Calculates discount from payment
export function calculateDiscountFrom(checkoutModel, couponCodeResponse) {

    let discount = 0
    if (couponCodeResponse) {
        let canUseThisPromoCode = false
        if (couponCodeResponse?.applies_to_all) {
            canUseThisPromoCode = true
        } else if (['pack', 'subscription', 'challenge'].includes(checkoutModel?.type ?? "") && couponCodeResponse?.applies_to_offerings?.includes(checkoutModel?.offering?.id)) {
            canUseThisPromoCode = true
        } else if (['dropin', 'rental'].includes(checkoutModel?.type ?? "") && 
        (couponCodeResponse?.applies_to_locationTypes?.includes(checkoutModel?.class?.location_type) || couponCodeResponse?.applies_to_class_ids?.includes(checkoutModel?.class?.id))) {
            canUseThisPromoCode = true
        }

        if (checkoutModel?.pricingOption){
            checkoutModel.payment = checkoutModel.pricingOption.price
        }

        if (!canUseThisPromoCode && !couponCodeResponse?.error?.message) {
            couponCodeResponse.error = {
                message: "This coupon can not be used on this pricing option"
            }
        }

        if (canUseThisPromoCode && couponCodeResponse.discount_amount) {
            console.log("can use this promo code: ", couponCodeResponse.discount_amount)
            switch (couponCodeResponse.discount_type) {
                case "percentage":
                    discount = (couponCodeResponse.discount_amount / 100) * checkoutModel.payment
                    break
                case "amount":
                    discount = couponCodeResponse.discount_amount
                    break
                case "gift":
                    discount = couponCodeResponse.discount_amount_remaining
                    break
            }
        }
    }

    if (checkoutModel?.type === 'subscription') {
        return discount
    }
    return Math.min(discount, checkoutModel.payment)
}

function CheckoutPricingSection({checkoutData, checkoutModel, handleCouponCodeChange, isLoading, ...otherProps}) {

    const currency = useSelector(state => state.widget.instructor.instructorProfile?.currency ?? "USD");
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });
    // console.log("CHeckout data", checkoutData)
    // console.log("CHeckout model", checkoutModel)
    const [selectedPricingOption, setSelectedPricingOption] = React.useState((checkoutModel?.offering?.pricingOptions && checkoutModel?.offering?.pricingOptions.length  > 0) ? checkoutModel?.offering?.pricingOptions[0] : null)

    let {feeAdditionCents, feeMultiple, couponCodeResponse} = checkoutData
    const checkoutTax = checkoutData.tax
    // console.log(checkoutData)
    let fee = 0;
    let tax = 0;
    let price = checkoutModel.payment;
    let total = checkoutModel.payment;
    let discount = 0
    let extraText = null

    if (checkoutModel.type === 'subscription' && checkoutModel.offering && checkoutModel.offering.isOneTimeOffer && checkoutModel.offering.discountType !== 'none') {
        let firstPeriodPrice = checkoutModel.payment;
        if (checkoutModel.offering.discountType === 'firstPeriodDiscount') {
            firstPeriodPrice = Number(checkoutModel.offering.firstPeriodPrice)
        } else if (checkoutModel.offering.discountType === 'freeTrial') {
            firstPeriodPrice = Number(0)
        }
        price = firstPeriodPrice
        total = firstPeriodPrice
        extraText = buildPricingTextFromOffering(checkoutModel.offering)
    } else if (checkoutModel.type === 'challenge' && checkoutModel.offering?.pricingOptions && checkoutModel.offering.pricingOptions.length > 0) {
        price = selectedPricingOption?.price ?? null
        total = selectedPricingOption?.price ?? null
        // console.log("Wahoo there! ")
    } else if (checkoutModel.offering && checkoutModel.offering.type === 'pack' && checkoutModel.offering.expires) {
        extraText = `Expires after ${checkoutModel.offering.expiresIn} days`
    }

    // console.log("Selected pricing option: ", selectedPricingOption)
    console.log("selected checkout model: ", checkoutModel)

    let showPromoCodeSection = checkoutModel?.type !== 'gift'
    const [openCouponCode, setOpenCouponCode] = React.useState(false)
    const [userCouponCode, setUserCouponCode] = React.useState(null)

    if (checkoutModel.promoCodePurchaseOnly && !openCouponCode) {
        setOpenCouponCode(true)
    }

    const {promoCode, dollarDiscount} = checkoutModel

    
    discount = promoCode === userCouponCode ? dollarDiscount : 0
    
    // Disregard coupon code response if you're using a challenge with a promo code only
    if (promoCode === userCouponCode) {
        couponCodeResponse = {}
    }

    if (!discount && promoCode !== userCouponCode) {
        discount = calculateDiscountFrom(checkoutModel, couponCodeResponse)
    }

    // console.log("DISCOUNT AMOUNT: ", discount)
    if (discount) {
        price = price - discount
        price = price > 0 ? price : price
        total = price
    }

    if (checkoutModel?.type === 'purchase') {
        showPromoCodeSection = false
    }

    if (checkoutTax && checkoutTax.rate) {
        tax = Math.round(100*(price * (checkoutTax.rate / 100))) / 100
        total = total + tax
    }

    console.log("TAX: ", tax)

    if (checkoutModel.type !== "subscription" && feeMultiple > 0 && price > 0) {

        // THIS IS THE CORRECT FORMULA
        const sutraFees = feeMultiple - 0.029
        const feeInCentsWithoutStripe = (total * sutraFees)
        const allCents = feeInCentsWithoutStripe + (feeAdditionCents / 100)
        fee = (Math.round(100*(total + allCents) / (1 - 0.029)) / 100) - (total)
    }

    total = total + fee

    const handleInputChange = (e) => {
        let copy = e.target.value
        copy = copy.replace(/\s/g, '')
        
        e.target.value = copy

        setUserCouponCode(copy)

        if (handleCouponCodeChange) {
            handleCouponCodeChange(copy)
        }
    }

    const handlePricingOptionChange = (index) => {
        if (!checkoutModel?.offering?.pricingOptions || checkoutModel.offering.pricingOptions.length < index + 1) {
            return
        }
        const pricingOption = checkoutModel.offering.pricingOptions[index]
        setSelectedPricingOption(pricingOption)

        if (otherProps.handlePricingOptionChange) {
            otherProps.handlePricingOptionChange(pricingOption)
        }
    }

    // switch (checkoutModel.type) {
    // case "dropin":
    //     price = checkoutModel.payment
    //     break;
    // case "purchase":
    //     price = 0;
    // case "subscription":
    //     price = chec
    // case "pack":
    // }

    
    const viewModel = {
        feeAmount: fee,
        dollarDiscount: discount,
        discount: currencyFormatter.format(discount),
        fee: currencyFormatter.format(fee),
        total: currencyFormatter.format(total > 0 ? total : 0),
        taxRate: `${checkoutTax?.rate ?? 0}%`,
        tax: currencyFormatter.format(tax),
        taxAmount: tax,
        taxName: checkoutTax?.name
    }

    console.log("Model: ", viewModel)
    // console.log("total: ", total)
    return (
        <>
        {true ? (
            
            <div>
                {checkoutModel?.offering?.pricingOptions?.length > 0 && (
                    <>
                    {checkoutModel.offering.pricingOptions.map((val, index) => (
                        <PricingOptionCell
                        key={index}
                        selected={selectedPricingOption?.name === val?.name}
                        onClick={() => handlePricingOptionChange(index)}
                        model={{
                            ...val,
                            price: currencyFormatter.format(val.price)
                        }}
                        />
                    ))}
                    </>
                )}
                {/* {promoCode && ( */}
                {showPromoCodeSection && (
                    <div className="mb-3">
                    {openCouponCode ? (
                        <>
                        <div className="d-flex align-items-center">
                            {/* <label>Code</label> */}
                            <input onChange={handleInputChange} type={"text"} placeholder={"Enter coupon code"} className={"form-control"} />
                            <button disabled={isLoading} className="btn btn-primary primaryColor" type="button" onClick={() =>{
                                if (otherProps.handleCouponCodeApply) {
                                    otherProps.handleCouponCodeApply()
                                }
                            }}>Apply
                                {/* {isLoading && (
                                    <Spinner
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden={true}
                                        className="ml-2"
                                    >
                                        <span className="sr-only">Sending...</span>
                                    </Spinner>
                                )} */}
                            </button>
                        </div>
                        {couponCodeResponse?.error?.message && (
                            <p style={{width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#ff4136"}}>
                                {couponCodeResponse?.error?.message}
                            </p>
                        )}
                        </>
                    ) : (
                        <div className="d-flex">
                            <button onClick={() => setOpenCouponCode(true)} className="p-0 btn btn-link primaryColor" type='button'>Have a promo code or gift?</button>
                        </div>
                        
                    )}
                    </div>
                )}
                {viewModel.dollarDiscount && !checkoutModel.promoCodePurchaseOnly ? (
    
                    <div className="d-flex d-row justify-content-between align-items-center">
                        <h6>Discount</h6>
                        <p>-&nbsp;{viewModel.discount}</p>
                    </div>
                ) : (<></>)}
                {(viewModel.tax && viewModel.taxAmount > 0) && !checkoutModel.promoCodePurchaseOnly ? (
                    <div className="d-flex d-row justify-content-between align-items-center">
                        <h6>{viewModel.taxName}</h6>
                        <p>{viewModel.tax}</p>
                    </div>
                ) : (<></>)}
                {(viewModel.feeAmount && viewModel.feeAmount > 0) && !checkoutModel.promoCodePurchaseOnly ? (
                    <div className="d-flex d-row justify-content-between align-items-center">
                        <h6>Processing Fees</h6>
                        <p>{viewModel.fee}</p>
                    </div>
                ) : (<></>)}
                {!checkoutModel.promoCodePurchaseOnly && (
                    <div className="d-flex d-row justify-content-between align-items-center">
                        <h6>Total</h6>
                        <p>{viewModel.total}</p>
                    </div>
                )}
                <div className="text-center">
                    {extraText}
                </div>
            </div>) : (<></>)}
        </>
    )
}



export default CheckoutPricingSection